
import {map, startWith} from 'rxjs/operators';
import { Component, DoCheck,  EventEmitter, Input, Output, ViewChild, ElementRef, OnInit} from '@angular/core';
import { trigger, state, style, animate, transition} from '@angular/animations';
import {SubmitterDetails, LegalEntityDetail, countries, PackageDetails} from "../model/lei-model";
import { FormControl, Validators} from '@angular/forms';
import { Observable } from 'rxjs';




@Component({
  selector: 'app-lei-details',
  templateUrl: './lei-details.component.html',
  styleUrls: ['./lei-details.component.scss'],
  animations: [
    trigger('signal', [
      state('close', style({
        'display': 'none',
        'opacity': '0.5',
      })),
      state('open', style({
        'display': 'block',
        'opacity': '1'
      })),
      transition('close => open', animate('0ms linear')),
      transition('open => close', animate('0ms linear'))
    ]),
    trigger('arrowRotate', [
      state('close', style({
        transform: "rotateZ(0deg)",
      })),
      state('open', style({
        transform: 'rotateZ(90deg)',
      })),
      transition('close => open', animate('100ms 100ms ease-out')),
      transition('open => close', animate('100ms 100ms ease-out'))
    ])
  ]
})
export class LeiDetailsComponent implements DoCheck, OnInit {
  submitter:SubmitterDetails = new SubmitterDetails();
  signal = 'close';
  arrowRotate = 'close';

  @ViewChild('legalEntityIdInput', { static: true }) legalEntityIdInput: ElementRef;

  public methods = [
    { value: 'P&L', display: 'P&L' },
    { value: 'RPA-SM', display: 'RPA Swedish Model' },
    { value: 'RPA-VTC', display: 'RPA funded via transaction charge' }
    ];

  public mifidScopes = [
    { value: 'IN', display: 'Yes and would like to receive research' },
    { value: 'REMOVE', display: 'In Scope however does not want access to research' },
    { value: 'OPTIN', display: 'Yes and want to opt-in to MiFID' },
    { value: 'OUT', display: 'No, my organization is out of scope' }
  ];

  public payViaRPAOptions = [
    { value: true, display: 'Yes' },
    { value: false, display: 'No' }
  ];

  public vatRegisteredOptions = [
    { value: true, display: 'Yes' },
    { value: false, display: 'No' }
  ];

  public currencies = [
    { value: 'USD', display: 'USD' },
    { value: 'EUR', display: 'EUR' },
    { value: 'GBP', display: 'GBP' }
  ];

  public countries = countries;

  legalEntityIdFormControl : FormControl;
  legalEntityNameFormControl : FormControl;
  legalEntityCountryFormControl : FormControl;
  //private mifidScopeFormControl : FormControl;

  private taxNumberFormControl : FormControl;

  private rpaAdminNameFormControl : FormControl;
  private rpaAdminEmailFormControl : FormControl;
  private rpaAdminPhoneFormControl : FormControl;

  private invoiceNameFormControl : FormControl;
  private invoiceEmailFormControl : FormControl;
  private invoicePhoneFormControl : FormControl;

  private line1FormControl : FormControl;
  private line2FormControl : FormControl;
  private cityFormControl : FormControl;
  private postcodeFormControl : FormControl;
  private invoiceCountryFormControl : FormControl;

  leiCountries: Observable<any>;
  private invoiceCountries: Observable<any>;

  @Input() isMifidRebundlingEnabled: boolean;
  @Input() leiDetail: LegalEntityDetail;
  @Input() packagesDetails: PackageDetails;
  @Input() submitterName : string;
  @Input() submitterEMail : string;
  @Output() cardStateChange: EventEmitter<any> = new EventEmitter();
  @Output() packagesModelChange: EventEmitter<any> = new EventEmitter();
  @Output() contactsModelChange: EventEmitter<any> = new EventEmitter();
  @Output() removeLeiFromModel: EventEmitter<any>  = new EventEmitter();
  @Output() navigationDisabled: EventEmitter<boolean> = new EventEmitter();
  @Output() copyInvoiceFromLastLei: EventEmitter<any> = new EventEmitter();
  @Output() copyLeiDetails: EventEmitter<any>  = new EventEmitter();

  constructor() {
    this.initializeFormControlsAndValidation();

  }

  ngDoCheck() {
    this.signal = this.leiDetail.isCardOpen ? 'open' : 'close';
    this.arrowRotate = this.signal;
  }


  ngOnInit() {
    this.leiCountries = this.legalEntityCountryFormControl.valueChanges.pipe(
      startWith<null, null>(null),
      map(val => val ? this.filter(val) : this.countries.slice()),);

    this.invoiceCountries = this.invoiceCountryFormControl.valueChanges.pipe(
      startWith<null, null>(null),
      map(val => val ? this.filter(val) : this.countries.slice()),);

    //MiFID rebundling enabled from 2023 onwards
    this.isMifidRebundlingEnabled = true;
  }

  filter(val: string): string[] {
    return this.countries.filter(country =>
    country.toLowerCase().indexOf(val.toLowerCase()) === 0);
  }


  private initializeFormControlsAndValidation() : void {

    let EMAIL_REGEX = /^[_A-Za-z0-9-\+]+(\.[_A-Za-z0-9-]+)*@[A-Za-z0-9-]+(\.[A-Za-z0-9]+)*(\.[A-Za-z]{2,})$/;

    this.legalEntityIdFormControl = new FormControl('', [
      Validators.required, Validators.minLength(20), Validators.pattern(/[a-zA-Z0-9]{20}$/)]);

    this.legalEntityNameFormControl = new FormControl('', [
      Validators.required]);

    this.legalEntityCountryFormControl = new FormControl('', [
      Validators.required]);

    this.taxNumberFormControl = new FormControl('', [
      Validators.required]);

    this.rpaAdminNameFormControl = new FormControl('', [
      Validators.required]);

    this.rpaAdminEmailFormControl = new FormControl('', [
      Validators.pattern(EMAIL_REGEX)]);

    this.rpaAdminPhoneFormControl = new FormControl();

    this.invoiceNameFormControl = new FormControl('', [
      Validators.required]);

    this.invoiceEmailFormControl = new FormControl('', [
      Validators.required, Validators.pattern(EMAIL_REGEX)]);

    this.invoicePhoneFormControl = new FormControl();

    this.line1FormControl = new FormControl('', [
      Validators.required]);

    this.line2FormControl = new FormControl();

    this.cityFormControl = new FormControl('', [
      Validators.required]);

    this.postcodeFormControl = new FormControl('', [
      Validators.required]);

    this.invoiceCountryFormControl = new FormControl('', [
      Validators.required]);

  }

  onArrowClick(event) {
    this.leiDetail.isCardOpen = !this.leiDetail.isCardOpen;
    this.signal = this.leiDetail.isCardOpen ? 'open' : 'close';
    this.arrowRotate = this.signal;
    this.cardStateChange.emit(this.leiDetail);
  }

  private addMorePackageForm(){
    this.packagesModelChange.emit(this.leiDetail);
  }

  private addMoreContactForm(){
    this.contactsModelChange.emit(this.leiDetail);
  }

  private ngAfterContentInit () {
      this.legalEntityIdInput.nativeElement.focus();
      // console.info(this.legalEntityIdInput);
    }

  private removeCurrentLei() {
    this.removeLeiFromModel.emit(this.leiDetail);
  }

  onMiFIDChange() {
    if(this.leiDetail.mifidInScope === 'IN' || this.leiDetail.mifidInScope === 'OPTIN' ){
      this.taxNumberFormControl.enable();
      this.rpaAdminNameFormControl.enable();
      this.rpaAdminEmailFormControl.enable();
      this.rpaAdminPhoneFormControl.enable();
      this.invoiceNameFormControl.enable();
      this.invoiceEmailFormControl.enable();
      this.invoicePhoneFormControl.enable();
      this.line1FormControl.enable();
      this.line2FormControl.enable();
      this.cityFormControl.enable();
      this.postcodeFormControl.enable();
    }
    else {
      this.taxNumberFormControl.disable();
      this.rpaAdminNameFormControl.disable();
      this.rpaAdminEmailFormControl.disable();
      this.rpaAdminPhoneFormControl.disable();
      this.invoiceNameFormControl.disable();
      this.invoiceEmailFormControl.disable();
      this.invoicePhoneFormControl.disable();
      this.line1FormControl.disable();
      this.line2FormControl.disable();
      this.cityFormControl.disable();
      this.postcodeFormControl.disable();
    }

  }

   displayMifidSelection() {

    this.leiDetail.packagesDetails[0].service = '';
    this.leiDetail.packagesDetails[0].products = [];
    this.leiDetail.packagesDetails[0].exemption = '';

    if(this.isMifidRebundlingEnabled) {
      this.mifidScopes = [
        {value: 'IN', display: 'Yes and would like to receive research'},
        {value: 'REMOVE', display: 'In Scope however does not want access to research'},
        {value: 'OUT', display: 'No, my organization is out of scope'}
      ];
      if (this.leiDetail.domicile !== 'United Kingdom') {
        this.leiDetail.packagesDetails[0].service = 'LT';
        this.leiDetail.packagesDetails[0].products.push('EQUITY', 'FICC');
        this.leiDetail.packagesDetails[0].exemption = 'Do not require UK FICC Exemption';
      }
    }
    this.showResearchCost();
    return true;
  }

  isPaymentShowable(){
    if(this.leiDetail.domicile === 'United Kingdom' && this.leiDetail.packagesDetails[0].products[0] === 'FICC'
      && this.leiDetail.packagesDetails[0].exemption === 'Require UK FICC Exemption'){
      return false;
    }
    else{
      return true;
    }
  }

  private onPaymentMethodChange() {
    if(this.leiDetail.paymentDetails.method && this.leiDetail.paymentDetails.method.match(/RPA/)) {
      this.leiDetail.paymentDetails.payViaRPA = true;
      this.rpaAdminNameFormControl.enable();
      this.rpaAdminEmailFormControl.enable();
      this.rpaAdminPhoneFormControl.enable();
    }
    else {
      this.leiDetail.paymentDetails.payViaRPA = false;
      this.rpaAdminNameFormControl.disable();
      this.rpaAdminEmailFormControl.disable();
      this.rpaAdminPhoneFormControl.disable();
    }
  }

  showResearchCost(){
    if(this.leiDetail.domicile === 'United Kingdom' && this.leiDetail.packagesDetails !== null){
      if((this.leiDetail.packagesDetails[0].products[0] === 'FICC')
        && this.leiDetail.packagesDetails[0].exemption === 'Require UK FICC Exemption'){
        this.leiDetail.researchCost = '0';
      }
      else{
        this.leiDetail.researchCost = '10000';
     }
    }
    else{
        this.leiDetail.researchCost ='10000';
    }
    return this.leiDetail.researchCost;
  }

  setNavigationDisable(contactsValid:boolean = false) {
    //if things are valid, then set nav disabled to false (means enable it), else true
    let valid : boolean = false;

    if(this.legalEntityIdFormControl.valid && this.legalEntityNameFormControl.valid && this.leiDetail.domicile.length >0 && this.leiDetail.mifidInScope != null) {
      if(!(this.leiDetail.mifidInScope === 'IN' || this.leiDetail.mifidInScope === 'OPTIN')) {
        valid = true;
      }
      else {
        //in scope or opt-in
        if(this.isMifidRebundlingEnabled && this.leiDetail.domicile === 'United Kingdom'
          && this.leiDetail.packagesDetails[0].products.includes('FICC') && this.leiDetail.packagesDetails[0].exemption === 'Require UK FICC Exemption'){
          this.showResearchCost();
          valid = this.checkPackageDetailsValidity();
        }
        else if((this.isMifidRebundlingEnabled && this.leiDetail.domicile !=='United Kingdom' ? true : this.checkPackageDetailsValidity()) && this.checkVATValidation() && this.checkRPAValidation() && this.checkInvoiceValidation()
          && this.checkCurrencyValidation() && this.checkContactsValidity(contactsValid))
          valid = true;
        }
    }

    valid === true ? this.navigationDisabled.emit(false) : this.navigationDisabled.emit(true);
  }

  private checkVATValidation():boolean {
    return ((this.leiDetail.paymentDetails.vatRegistered !=null && this.leiDetail.paymentDetails.vatRegistered === false) ||
      (this.leiDetail.paymentDetails.vatRegistered !=null && this.leiDetail.paymentDetails.vatRegistered === true && this.taxNumberFormControl.valid))
  }

  private checkCurrencyValidation():boolean {
    return this.leiDetail.paymentDetails.preferredCurrency != null;
  }

  private checkRPAValidation() : boolean {
    return  ((this.leiDetail.paymentDetails.method.length > 0 && this.leiDetail.paymentDetails.method === 'P&L') ||
    (this.leiDetail.paymentDetails.method.length > 0 && this.leiDetail.paymentDetails.method != 'P&L' && this.rpaAdminNameFormControl.valid))
  }

  private checkInvoiceValidation() : boolean {
    return this.invoiceNameFormControl.valid && this.invoiceEmailFormControl.valid && this.line1FormControl.valid
      && this.cityFormControl.valid && this.postcodeFormControl.valid && this.leiDetail.invoiceDetails.address.country.length > 0;
  }

  private checkPackageDetailsValidity() : boolean {
    return this.leiDetail.packagesDetails[0].service.length > 0  &&  this.leiDetail.packagesDetails[0].products.length > 0
      &&  this.leiDetail.packagesDetails[0].exemption.length>0;
  }

  private checkContactsValidity(contactsValid:boolean) : boolean {
    let EMAIL_REGEX = /^[_A-Za-z0-9-\+]+(\.[_A-Za-z0-9-]+)*@[A-Za-z0-9-]+(\.[A-Za-z0-9]+)*(\.[A-Za-z]{2,})$/;

    return contactsValid || this.leiDetail.contacts[0].name.length > 0 &&  this.leiDetail.contacts[0].email.length > 0
      &&  EMAIL_REGEX.test(this.leiDetail.contacts[0].email) && this.leiDetail.contacts[0].job.length > 0 && this.leiDetail.contacts[0].location.length >0;
  }

  private copyInvoiceDetails(e) {
    if(e.target.checked) {
      this.copyInvoiceFromLastLei.emit({ event:this.leiDetail, copy: true });
    }
    else {
      this.copyInvoiceFromLastLei.emit({ event:this.leiDetail, copy: false });
    }
  }

  copyLei(e) {
      this.copyLeiDetails.emit({ event:this.leiDetail});
  }

}
